import React, { useEffect, useState } from 'react';
import Modal from './modal';
import "../styles/modal-add-note.css"
import axios from 'axios';
import noteService from '../../services/noteService';

const ModalAddNote = ({ isOpen, onClose, onAddNote }) => {
  const [program, setProgram] = useState('');
  const [programs, setPrograms] = useState([]);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [titleError, setTitleError] = useState("");
  const [contentError, setContentError] = useState("");

  useEffect(() => { // get all the program objects from the db
        const fetchPrograms = async () => {
            try {
                const fetchedPrograms = await noteService.getPrograms();
                setPrograms(fetchedPrograms);
                if (fetchedPrograms.length > 0) {
                    setProgram(fetchedPrograms[0].id);
                }
            } catch (error) {
                console.error('Error fetching programs:', error);
            }
        };

        fetchPrograms();
    }, []);

  // Resets modal after close
  const handleModalClose = () => {
    setContentError("");
    setTitleError("");
    setTitle("");
    setContent("");
    setProgram('');
    onClose();
  };

  // Error message for when a title is not inputted or exceeds 50 characters
  const validateTitle = () => {
    setTitleError("");

    if(!title.trim()) {
      setTitleError("Title is required");
      return false;
    }

    if(title.length > 50){
      setTitleError("Title cannot exceed 50 characters");
      return false
    }

    return true;
  };

  // Error message for when description exceeds 500 characters
  const validateContent = () => {
    setContentError("");
    if(content.length > 500){
      setContentError("Description cannot exceed 500 characters");
      return false;
    }
    return true;
  };

  // Creates a new note
  const handleAddClick = (event) => {
    event.preventDefault();

    if(!validateTitle() ||!validateContent()) {return;}
    
    const newNote = {
      title: title,
      content: content,  // changed from 'description' to 'content'
      program_id: program   // include program value
    };
    
    onAddNote(newNote);
    
    // Resets Modal after add
    setTitle("");
    setContent("");
    setProgram('');
  };

  return (
    <Modal isOpen={isOpen} onClose={handleModalClose}>
      <div className="notesModal-wrapper">
          <div className="notesModal-header">
            <h1 className="notes-header-text">Add Note</h1>
          </div>
          <div className="notes-editor-container">
            <div>
              <form className="create-note" onSubmit={(event)=> handleAddClick(event)}> 
                <input
                value={title}
                onChange={(event)=> {
                  setTitle(event.target.value);
                  if (event.target.value.trim() && titleError) {
                    setTitleError("");
                  }
                }
                }
                placeholder="Title"
                className={titleError ? "error-input" : ""}
                />
                {titleError && <p className='error-message'>{titleError}</p>}
              
                <textarea
                  value={content}
                  onChange={(event)=> {
                    setContent(event.target.value);
                    if (contentError && event.target.value.length <= 500) {
                      setContentError("");
                    }
                  }
                  }
                  placeholder="Description"
                  rows={5}
                  className={contentError ? "error-input" : ""}
                />

                {contentError && <p className='error-message'>{contentError}</p>}
              </form>
              <div className="notes-filters-modal">
                {/* Display all available options for program names in select box - sky*/}
                <select 
                  value={program} 
                  onChange={(e) => setProgram(e.target.value)}
                  className="notes-select"
                >
                  {programs.map(p => (
                      <option key={p.id} value={p.id}>{p.program}</option>
                  ))}
                </select>
              </div>
              <div className="modify-notes-btns">
                <button className="cancel-note-btn" onClick={handleModalClose}>Cancel</button>
                <button className="add-note-btn" onClick={handleAddClick}>Add Note</button>
              </div>
            </div>
          </div>
        </div>
    </Modal>
  );
};

export default ModalAddNote;